import React, { FC } from 'react'
import Image from 'next/image'
import { Box, Text, VStack } from '@chakra-ui/react'
import { H2Title, ListWithDescription, TextLink } from 'src/uikit'
import { ArrowForwardIcon } from '@chakra-ui/icons'
import QuadrilateroVerde from 'public/images/quadrilatero_verde'

interface Props {
  image: string
  title: string
  items: Array<ListGlobal.WithDescription>
  href?: string
  action?: string
  actionTitle?: string
  footer: string
}

const BeforeNltSection: FC<Props> = ({ image, title, items, href, action, actionTitle, footer }) => (
  <VStack align="stretch" overflow="hidden">
    <Box bg="baseWhite" p="l" pt="xxl" pb="20rem" pos="relative">
      <H2Title mb="7" fontSize="1.25rem" lineHeight="1.938rem" color="baseDark" textAlign="center">
        {title}
      </H2Title>
      <ListWithDescription items={items} />
      <Text
        color="baseDark"
        fontFamily="Montserrat-Medium"
        fontSize=".75rem"
        lineHeight="15.6px"
        letterSpacing="0.4px"
        textAlign="left"
        paddingTop="l"
      >
        {footer}
      </Text>
      <Box position="relative" mt="8" mx="-6" textAlign="left">
        <Box position="absolute" h="17.25rem" right="-3">
          <QuadrilateroVerde flip={true} color="#2ec58d" h={218} w={172} />
        </Box>
        <Box position="absolute" top="calc(50% + 18px)" left="5">
          <Image
            src={image}
            alt={title}
            width="364"
            height="190"
            objectFit="contain"
            loading="lazy"
            decoding="async"
          />
          {href && (
            <TextLink
              fontFamily="Montserrat-Medium"
              fontSize="1rem"
              color="baseDark"
              href={href}
              title={actionTitle}
              display="inline-block"
              paddingTop="var(--cp-space-s)"
            >
              {action} <ArrowForwardIcon />
            </TextLink>
          )}
        </Box>
      </Box>
    </Box>
  </VStack >
)

export default BeforeNltSection
